import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import HeaderLabel from '../HeaderLabel';

import { Box, Column, Strong } from './HeaderLabels.style';

const HeaderLabels = ({ labels }) => {
  return (
    <Box>
      <Column>
        {labels &&
          labels.length > 0 &&
          labels
            .filter((label) => label.column === 'LEFT')
            .map((label, key) => (
              <Fragment key={key}>
                <HeaderLabel>
                  {label.title}: <Strong>{label.value}</Strong>
                </HeaderLabel>
              </Fragment>
            ))}
      </Column>
      <Column>
        {labels &&
          labels.length > 0 &&
          labels
            .filter((label) => label.column === 'RIGHT')
            .map((label, key) => (
              <Fragment key={key}>
                <HeaderLabel>
                  {label.title}: <Strong>{label.value}</Strong>
                </HeaderLabel>
              </Fragment>
            ))}
      </Column>
    </Box>
  );
};

HeaderLabels.propTypes = {
  labels: PropTypes.array,
};

export default HeaderLabels;
